module.exports = __webpack_public_path__ + "media/base/eye-d44d360f.svg";